/*** IMPORTS FROM imports-loader ***/
var define = false;

import { polyfill as promisePolyfill } from 'es6-promise';
import each from 'lodash';
import picturefill from 'picturefill';
import 'whatwg-fetch';

//

promisePolyfill();

//

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function closest(s) {
    let el = this;

    do {
      if (el.matches(s)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

//

const observer = new MutationObserver((mutations) => {
  each(mutations, (mutation) => {
    each(mutation.addedNodes, (node) => {
      if (node.nodeType !== 1) {
        return;
      }

      const els = node.querySelectorAll('picture');
      if (!els.length) {
        return;
      }

      picturefill();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  picturefill();
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
});

